import level1 from '@/pages/main/level1/level1'

// 收支记账
import revenbook from '@/pages/main/level1/reven/reven_book/index'

// 设置
// 数据中心
import plateorder from '@/pages/main/level1/data_center/plateorder/index'
import platebill from '@/pages/main/level1/data_center/platebill/index'
import promotion from '@/pages/main/level1/data_center/promotion/index'
import offbilling from '@/pages/main/level1/data_center/offbilling/index'
import offbillingafter from '@/pages/main/level1/data_center/offbillingafter/index'
import offbillingreissue from '@/pages/main/level1/data_center/offbillingreissue/index'
// 京东售后
import jdsh from '@/pages/main/level1/data_center/jdshouhou/index'

// 店铺管理
import shoplist from '@/pages/main/level1/shopmanage/shoplist/index'
// 权限管理


// 人员管理
import personment from '@/pages/main/level1/power_ment/personment/index'
// 角色权限管理
import rolement from '@/pages/main/level1/power_ment/rolement/index'
// 路由
import manager from '@/pages/main/level1/power_ment/manager/index'

// 目标设置
// 综合指标设置
import synthetical from '@/pages/main/level1/targetset/synthetical/index'
// 公司目标设置
import companytarget from '@/pages/main/level1/targetset/companytarget/index'
// 人员目标设置
import persontarget from '@/pages/main/level1/targetset/persontarget/index'


// 模板管理
// 成本模板及配置
import costset from '@/pages/main/level1/goodsmanage/costset/index'
// 订单费用模板
import costorder from '@/pages/main/level1/goodsmanage/costorder/index'
// 责权模板配置
import costduty from '@/pages/main/level1/goodsmanage/costduty/index'


// 渠道追踪
// 全渠道-全渠道核心
import channelcore from '@/pages/main/level1/channel/channelcore/index'
// 特殊单分析
import special from '@/pages/main/level1/channel/special/index'
// 绩效分析
import merits from '@/pages/main/level1/channel/merits/index'
// 淘宝-运营概况
import operation from '@/pages/main/level1/taobao/operation/index'
// 推广分析
import popularize from '@/pages/main/level1/taobao/popularize/index'
// 目标追踪
import target from '@/pages/main/level1/taobao/target/index'
// 拼多多-运营概况
import opersitu from '@/pages/main/level1/pinduoduo/opersitu/index'
// 推广分析
import pddpopularize from '@/pages/main/level1/pinduoduo/pddpopularize/index'
// 目标追踪
import pddtarget from '@/pages/main/level1/pinduoduo/pddtarget/index'
// 京东-运营概况
import jdopersitu from '@/pages/main/level1/jingdong/jdopersitu/index'
// 推广分析
import jdpopularize from '@/pages/main/level1/jingdong/jdpopularize/index'
// 目标追踪
import jdtarget from '@/pages/main/level1/jingdong/jdtarget/index'






// 经营分析
// 财务报表
import dashboardcompre from '@/pages/main/level1/dashboard/dashboardcompre/index'
// 利润日报
import profit from '@/pages/main/level1/dashboard/profit/index'
// 渠道
import channel from '@/pages/main/level1/dashboard/channel/index'
// 店铺
import store from '@/pages/main/level1/dashboard/store/index'
// 商品链接
import shoplink from '@/pages/main/level1/dashboard/shoplink/index'
// 商品编码
import encoding from '@/pages/main/level1/dashboard/encoding/index'
// 规格编码
import specicode from '@/pages/main/level1/dashboard/specicode/index'
// 外部编码
import outwardcode from '@/pages/main/level1/dashboard/outwardcode/index'

// 渠道
import channeloper from '@/pages/main/level1/opertable/channeloper/index'
// 店铺
import shopoper from '@/pages/main/level1/opertable/shopoper/index'
// 商品链接
import linkoper from '@/pages/main/level1/opertable/linkoper/index'
// 商品编码
import codeoper from '@/pages/main/level1/opertable/codeoper/index'
// 规格编码
import specioper from '@/pages/main/level1/opertable/specioper/index'
// 规格编码
import outwardoper from '@/pages/main/level1/opertable/outwardoper/index'

// 平台费用
import terrace from '@/pages/main/level1/costmanage/terrace/index'
// 科目费用
import subject from '@/pages/main/level1/costmanage/subject/index'







export default {
  path: 'level1',
  name: 'level1',
  component: level1,
  redirect: './level1/level1-1',
  children: [
    {
      path: 'revenbook',
      name: 'revenbook',
      component: revenbook,
    },
    {
      path: 'jdsh',
      name: 'jdsh',
      component: jdsh,
    },
    {
      path: 'plateorder',
      name: 'plateorder',
      component: plateorder,
    },
    {
      path: 'platebill',
      name: 'platebill',
      component: platebill,
    },
    {
      path: 'promotion',
      name: 'promotion',
      component: promotion,
    },
    {
      path: 'offbilling',
      name: 'offbilling',
      component: offbilling,
    },
    {
      path: 'offbillingafter',
      name: 'offbillingafter',
      component: offbillingafter,
    },
    {
      path: 'offbillingreissue',
      name: 'offbillingreissue',
      component: offbillingreissue,
    },
    {
      path: 'shoplist',
      name: 'shoplist',
      component: shoplist,
    },
    {
      path: 'personment',
      name: 'personment',
      component: personment,
    },
    {
      path: 'rolement',
      name: 'rolement',
      component: rolement,
    },
    {
      path: 'manager',
      name: 'manager',
      component: manager,
    },
    {
      path: 'synthetical',
      name: 'synthetical',
      component: synthetical,
    },
    {
      path: 'companytarget',
      name: 'companytarget',
      component: companytarget,
    },
    {
      path: 'persontarget',
      name: 'persontarget',
      component: persontarget,
    },
    {
      path: 'costset',
      name: 'costset',
      component: costset,
    },
    {
      path: 'costorder',
      name: 'costorder',
      component: costorder,
    },
    {
      path: 'costduty',
      name: 'costduty',
      component: costduty,
    },
    {
      path: 'channelcore',
      name: 'channelcore',
      component: channelcore,
    },
    {
      path: 'special',
      name: 'special',
      component: special,
    },
    {
      path: 'merits',
      name: 'merits',
      component: merits,
    },
    {
      path: 'operation',
      name: 'operation',
      component: operation,
    },
    {
      path: 'popularize',
      name: 'popularize',
      component: popularize,
    },
    {
      path: 'target',
      name: 'target',
      component: target,
    },
    {
      path: 'opersitu',
      name: 'opersitu',
      component: opersitu,
    },
    {
      path: 'pddpopularize',
      name: 'pddpopularize',
      component: pddpopularize,
    },
    {
      path: 'pddtarget',
      name: 'pddtarget',
      component: pddtarget,
    },
    {
      path: 'jdopersitu',
      name: 'jdopersitu',
      component: jdopersitu,
    },
    {
      path: 'jdpopularize',
      name: 'jdpopularize',
      component: jdpopularize,
    },
    {
      path: 'jdtarget',
      name: 'jdtarget',
      component: jdtarget,
    },

    {
      path: 'dashboardcompre',
      name: 'dashboardcompre',
      component: dashboardcompre,
    },
    {
      path: 'profit',
      name: 'profit',
      component: profit,
    },
    {
      path: 'channel',
      name: 'channel',
      component: channel,
    },
    {
      path: 'store',
      name: 'store',
      component: store,
    },
    {
      path: 'shoplink',
      name: 'shoplink',
      component: shoplink,
    },
    {
      path: 'encoding',
      name: 'encoding',
      component: encoding,
    },
    {
      path: 'specicode',
      name: 'specicode',
      component: specicode,
    },
    {
      path: 'outwardcode',
      name: 'outwardcode',
      component: outwardcode,
    },
    {
      path: 'channeloper',
      name: 'channeloper',
      component: channeloper,
    },
    {
      path: 'shopoper',
      name: 'shopoper',
      component: shopoper,
    },
    {
      path: 'linkoper',
      name: 'linkoper',
      component: linkoper,
    },
    {
      path: 'codeoper',
      name: 'codeoper',
      component: codeoper,
    },
    {
      path: 'specioper',
      name: 'specioper',
      component: specioper,
    },
    {
      path: 'outwardoper',
      name: 'outwardoper',
      component: outwardoper,
    },
    {
      path: 'terrace',
      name: 'terrace',
      component: terrace,
    },
    {
      path: 'subject',
      name: 'subject',
      component: subject,
    },


  ]

}




// WEBPACK FOOTER //
// ./src/router/level1.js